module.exports = __webpack_public_path__ + "39bdfdc68fcd35406c50468f030e3073.svg";